<section class="banks-card" aria-label="Bancos da operação">
  <header class="banks-card__head">
    <h3 class="banks-card__title">
      <i class="pi pi-building-columns" aria-hidden="true"></i>
      Bancos da operação
    </h3>
    <span class="banks-card__count">{{ store.cards().length }}</span>
  </header>

  <!-- A coluna lateral é estreita: o nome e a etiqueta dividem a 1ª linha e o valor fica sozinho na 2ª, sem quebrar
       no meio do número. -->
  <ul class="banks-card__list">
    @for (card of store.cards(); track card.pipelineDealId) {
      <li>
        <button
          type="button"
          class="banks-card__row"
          [title]="'Ver os comentários do ' + (card.bankName || 'banco')"
          (click)="store.openComments(card)">
          <span class="banks-card__logo">
            @if (card.bankCompensationCode) {
              <app-bank-logo [code]="card.bankCompensationCode" [maxWidth]="22" />
            } @else {
              <i class="pi pi-building-columns" aria-hidden="true"></i>
            }
          </span>
          <span class="banks-card__texts">
            <span class="banks-card__top">
              <span class="banks-card__bank">{{ card.bankName || 'Banco não informado' }}</span>
              <span class="banks-card__tag" [ngClass]="'banks-card__tag--' + stageTone(card.stage)">
                {{ stageLabel(card.stage) }}
              </span>
            </span>
            <span class="banks-card__meta">
              <span>{{ card.currencyCode }} {{ card.value | vaultFormatCurrency: 2 }}</span>
              @if (card.commentCount) {
                <span
                  class="banks-card__comments"
                  [title]="
                    card.commentCount === 1 ? '1 comentário' : card.commentCount + ' comentários'
                  ">
                  <i class="pi pi-comment" aria-hidden="true"></i>
                  {{ card.commentCount }}
                </span>
              }
            </span>
          </span>
        </button>
      </li>
    }
  </ul>

  <app-button
    label="Ver todos os bancos"
    icon="pi pi-arrow-right"
    iconPosition="right"
    [theme]="'link'"
    [noMargin]="true"
    (sendButtonClick)="viewAll.emit()" />
</section>
